// extracted by mini-css-extract-plugin
export var dayLabel = "_kl-0";
export var pickerDisabled = "_kl-1";